export const CATEGORIES = [
  { k: "fire", name: "Firefighter", color: "var(--color-cat-firefighter)" },
  { k: "ems", name: "EMS", color: "var(--color-cat-ems)" },
  { k: "aha", name: "AHA", color: "var(--color-cat-aha)" },
  { k: "res", name: "Rescue", color: "var(--color-cat-rescue)" },
];
